(function () {
  'use strict';

  function selectionFromButton(button, language) {
    if (!button || !language) return null;
    const {clId: id, clSku: sku, clName: name, clLabel: label, clPreset: preset, clImage: image, clPortrait: portrait, clAlt: alt} = button.dataset;
    if (!/^\d+$/.test(id || '') || !name || !preset || !image || sku !== `eclat|${preset}|${language}|off`) return null;
    return {id, sku, name, ...(label ? {label} : {}), preset, image, ...(portrait ? {portrait} : {}), alt: alt || name};
  }

  function initialize(root) {
    if (root.dataset.clLanguageReady === 'true') return;
    const form = root.querySelector('[data-cl-language-form]');
    const hero = root.querySelector('[data-cl-language-hero]');
    const sticker = root.querySelector('[data-cl-language-sticker]');
    const avatar = sticker?.querySelector('[data-eclat-avatar]');
    const stickerImage = sticker?.querySelector('[data-eclat-sticker]');
    const buttons = Array.from(root.querySelectorAll('[data-cl-language-model]'));
    if (!form || !hero || !buttons.length) return;
    const variantInput = form.querySelector('[data-cl-language-variant]');
    const nameInput = form.querySelector('[data-cl-language-name]');
    const presetInput = form.querySelector('[data-cl-language-preset]');
    const selectedName = root.querySelector('[data-cl-language-selected]');
    const status = root.querySelector('[data-cl-language-status]');
    const buy = form.querySelector('button[type="submit"]');
    if (!variantInput || !nameInput || !presetInput || !selectedName || !status || !buy) return;

    function choose(button, announce) {
      const selection = selectionFromButton(button, root.dataset.clLanguage);
      if (!selection || !buttons.includes(button)) return false;
      buttons.forEach(model => model.setAttribute('aria-pressed', String(model === button)));
      hero.src = selection.image;
      hero.alt = selection.alt;
      const useSticker = Boolean(avatar && stickerImage && selection.portrait);
      if (useSticker) {
        avatar.src = selection.portrait;
        stickerImage.setAttribute('aria-label', selection.alt);
        stickerImage.dataset.eclatName = selection.name;
      }
      if (sticker) sticker.hidden = !useSticker;
      hero.hidden = useSticker;
      variantInput.value = selection.id;
      nameInput.value = selection.name;
      presetInput.value = selection.preset;
      selectedName.textContent = selection.label || selection.name;
      if (announce) status.textContent = `${root.dataset.clLanguageAnnounce || ''} ${selection.label || selection.name}`.trim();
      return true;
    }

    buttons.forEach(button => button.addEventListener('click', () => choose(button, true)));
    const initial = buttons.find(button => button.getAttribute('aria-pressed') === 'true');
    if (!choose(initial, false)) buy.disabled = true;
    form.addEventListener('submit', event => {
      const selected = buttons.filter(button => button.getAttribute('aria-pressed') === 'true');
      const choice = selected.length === 1 ? selectionFromButton(selected[0], root.dataset.clLanguage) : null;
      if (!choice || variantInput.value !== choice.id || nameInput.value !== choice.name || presetInput.value !== choice.preset) event.preventDefault();
    });
    root.dataset.clLanguageReady = 'true';
  }

  function boot(scope) { scope.querySelectorAll('[data-cl-language-landing]').forEach(initialize); }
  if (typeof module !== 'undefined' && module.exports) module.exports = {selectionFromButton, initialize};
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
    else boot(document);
    document.addEventListener('shopify:section:load', event => boot(event.target));
  }
})();
